import { Directive, TemplateRef, inject } from '@angular/core';
import type { QpxOverflowTriggerTemplateContext } from './models';

@Directive({
    selector: 'ng-template[qpxOverflowTriggerTpl]',
})
export class QpxOverflowTriggerTemplate {
    public readonly templateRef =
        inject<TemplateRef<QpxOverflowTriggerTemplateContext>>(TemplateRef);

    static ngTemplateContextGuard(
        _dir: QpxOverflowTriggerTemplate,
        _ctx: unknown
    ): _ctx is QpxOverflowTriggerTemplateContext {
        return true;
    }
}
